import { Effect } from "../Materials/effect";
var name = 'vrMultiviewToSingleviewPixelShader';
var shader = "precision mediump sampler2DArray;\nvarying vec2 vUV;\nuniform sampler2DArray multiviewSampler;\nuniform int imageIndex;\nvoid main(void)\n{\ngl_FragColor=texture(multiviewSampler,vec3(vUV,imageIndex));\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var vrMultiviewToSingleviewPixelShader = { name: name, shader: shader };
//# sourceMappingURL=vrMultiviewToSingleview.fragment.js.map